// Firebase
import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getDatabase, connectDatabaseEmulator } from "firebase/database";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";


const app = initializeApp({
    apiKey: "AIzaSyDROApW8DW-7Mvu3ybTdxbPhEslPZ4Rsmw",
    authDomain: "clgmbh-logistikmonitor.firebaseapp.com",
    databaseURL: "https://clgmbh-logistikmonitor.firebaseio.com",
    projectId: "clgmbh-logistikmonitor",
    storageBucket: "clgmbh-logistikmonitor.appspot.com",
    messagingSenderId: "283537869289",
    appId: "1:283537869289:web:dcdb99c0dd537bbb08e378",
});

const auth = getAuth(app);
const db = getDatabase(app);
const firestore = getFirestore(app);
const functions = getFunctions(app, "europe-west3");

if (location.hostname === "localhost") {
    connectAuthEmulator(auth, "http://localhost:9099", { disableWarnings: true });
    connectDatabaseEmulator(db, "localhost", 9002);
    connectFirestoreEmulator(firestore, "localhost", 8081);
    connectFunctionsEmulator(functions, "localhost", 5001);
}

export { auth, db, firestore, functions }